import IncomeVsExpenseView from '../Insights/IncomeVsExpense/IncomeVsExpenseView';
import { useDispatch } from "react-redux";
import { setInitialFilterConf, setFilterData } from '../../slices/filters/thunk';
import { useEffect } from 'react';
import utils from '../../Common/utils';

const ProjectIncomeVsExpenseTab = ({ projData, isActive }) => {

  const dispatch = useDispatch();

  useEffect(() => {
    if (!isActive) return;
    dispatch(setInitialFilterConf({
      data: {
        'aggregation_period': 'month',
      },
      hidden: ['*'],
    }))
    dispatch(setFilterData(utils.getObjectFromURL()))
  }, [isActive]);

  if (!projData?.id || !isActive) return null;
  return <IncomeVsExpenseView staticParams={{ projects: [projData.id] }} />;
};

export default ProjectIncomeVsExpenseTab;
